<template>
    <div class="">
        <div class="">
            <div class="ticker-wrap-multi-line">
                <p class="ticker-text ticker-text-left gotham-bold mb-0">
                    project &amp; corporate identity creation <span class="gotham-book">print ad</span> brochure &amp; direct mail design 
                    project &amp; corporate identity creation <span class="gotham-book">print ad</span> brochure &amp; direct mail design 
                    project &amp; corporate identity creation <span class="gotham-book">print ad</span> brochure &amp; direct mail design 
                    project &amp; corporate identity creation <span class="gotham-book">print ad</span> brochure &amp; direct mail design 
                    project &amp; corporate identity creation <span class="gotham-book">print ad</span> brochure &amp; direct mail design 
                </p>
                <p class="ticker-text ticker-text-right-2 gotham-bold mb-0">
                    <span class="gotham-book">website design, development, hosting &amp; management</span> social media/content 
                    <span class="gotham-book">website design, development, hosting &amp; management</span> social media/content 
                    <span class="gotham-book">website design, development, hosting &amp; management</span> social media/content 
                    <span class="gotham-book">website design, development, hosting &amp; management</span> social media/content 
                    <span class="gotham-book">website design, development, hosting &amp; management</span> social media/content 
                </p>
                <p class="ticker-text ticker-text-left-2 gotham-bold mb-0">
                    marketing &amp; digital advertising <span class="gotham-book">media planning</span> interior design &amp; décor 
                    marketing &amp; digital advertising <span class="gotham-book">media planning</span> interior design &amp; décor 
                    marketing &amp; digital advertising <span class="gotham-book">media planning</span> interior design &amp; décor 
                    marketing &amp; digital advertising <span class="gotham-book">media planning</span> interior design &amp; décor 
                    marketing &amp; digital advertising <span class="gotham-book">media planning</span> interior design &amp; décor 
                </p>
                <p class="ticker-text ticker-text-right gotham-bold mb-0">
                    consulting <span class="gotham-book">signage design, production &amp; installation</span> sales event promotion 
                    consulting <span class="gotham-book">signage design, production &amp; installation</span> sales event promotion 
                    consulting <span class="gotham-book">signage design, production &amp; installation</span> sales event promotion 
                    consulting <span class="gotham-book">signage design, production &amp; installation</span> sales event promotion 
                    consulting <span class="gotham-book">signage design, production &amp; installation</span> sales event promotion 
                </p>
                <p class="ticker-text ticker-text-left gotham-bold mb-0">>
                    &amp; management <span class="gotham-book">television, radio &amp; web video advertising</span> project &amp; corporate identity creation 
                    &amp; management <span class="gotham-book">television, radio &amp; web video advertising</span> project &amp; corporate identity creation 
                    &amp; management <span class="gotham-book">television, radio &amp; web video advertising</span> project &amp; corporate identity creation 
                    &amp; management <span class="gotham-book">television, radio &amp; web video advertising</span> project &amp; corporate identity creation 
                    &amp; management <span class="gotham-book">television, radio &amp; web video advertising</span> project &amp; corporate identity creation 
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
export default {
    data() {
        return {
            tickerMultipleGSAP: null
        }
    },
    mounted() {
        this.tickerMultipleGSAP = gsap;
        this.tickerMultipleGSAP.to('.ticker-text-left', {
            x: -500,
            ease: 'Power1.easeInOut',
            scrollTrigger: {
                trigger: ".ticker-wrap-multi-line",
                scrub: 1
            }
        })
        this.tickerMultipleGSAP.from('.ticker-text-right', {
            x: -500,
            ease: 'Power1.easeInOut',
            scrollTrigger: {
                trigger: ".ticker-wrap-multi-line",
                scrub: 1
            }
        })
        this.tickerMultipleGSAP.to('.ticker-text-left-2', {
            x: -400,
            ease: 'linear',
            scrollTrigger: {
                trigger: ".ticker-wrap-multi-line",
                scrub: 1
            }
        })
        this.tickerMultipleGSAP.from('.ticker-text-right-2', {
            x: -400,
            ease: 'Power3.easeInOut',
            scrollTrigger: {
                trigger: ".ticker-wrap-multi-line",
                scrub: 1
            }
        })
    },
    beforeDestroy() {
        
    }
}
</script>

<style scoped lang="scss">
.ticker-wrap-multi-line {
    overflow-x: hidden;
    white-space: nowrap;
    z-index: 1;
    max-width: 100%;
    color: #000;
}

.ticker-text {
    font-size: 1.75rem;

    @media screen and (max-width: 767px) {
        font-size: 1rem;
    }
}
</style>